import React from "react";
import Seo from "@/utils/seo";
import BannerCard from "@/components/ui/banner-card";
import Problem from "@/components/pages/initiatives/problem";
import Solution from "@/components/pages/initiatives/solution";
import SolutionGrid from "@/components/pages/initiatives/solution-grid";
import CaseStories from "@/components/pages/mrc/case-stories";
import Head from "next/head";
import Section from "@/components/ui/section";

export default function GRI() {
  const seo = {
    slug: "/grassroots-leadership-and-capacity",
    metaTitle:
      "Grassroots leadership & capacity | People’s Courage International, South & Southeast Asia",
    metaDescription:
      "We collaborate with Community-Based Organizations (CBOs) and assist them in building their OD capacity.",
  };
  const jsonLd = {
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: "People’s Courage International",
    description:
      "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3206 10th Street NE, Washington",
      addressLocality: "DC",
      postalCode: "20017",
      addressCountry: "USA",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1202-573-8727",
      contactType: "customer support",
    },
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "Grassroots Leadership & Capacity",
          image: "/images/gri/pci-gri-banner.webp",
        }}
        isActive={true}
        variant="single"
      />
      <Problem
        image="/images/gri/gri-problem.webp"
        descriptionOne="Over the years, the grassroots civil societies organizations (CSOs) have done remarkable work which has made their contributions indispensable for several reasons such as effective community engagement, local knowledge & expertise and building resilience of the communities."
        descriptionTwo="CSOs, especially those led by individuals from disempowered communities, have always faced challenges in maintaining and expanding their work. Despite playing a crucial role in deep community work, these organizations receive very negligible support of any kind due to a lack of awareness among funders. Due to the lack of Organizational Development (OD) funding, their growth in critical areas such as strategy, policy compliance, and fundraising is significantly hindered."
      />
      <Solution
        image="/images/gri/gri-solution.webp"
        description="We collaborate with Community-Based Organizations (CBOs) and assist them in building their OD capacity. We aim to provide comprehensive support to the CSOs that will enable them in holistically furthering their mission. This will be enabled by providing capacity-building support in these organizations in the following areas:<br/><ul><li>Financial Management and Compliances</li><li>Leadership, Governance, and Policies</li><li>Fundraising and Donor Management</li></ul>"
      />
      <SolutionGrid
        columns={3}
        data={[
          {
            title: "Flexible",
            image: "/images/gri/flexible.png",
            description:
              "Flexible in our approach, considering the size and stage of the organization and the type of support required.",
          },
          {
            title: "Customizable",
            image: "/images/gri/customisable.png",
            description:
              "Adaptable to the specific needs of each organization, ranging from 3-5 years of support through a mix of cohort-based workshops, 1:1 coaching sessions, and a series of expert sessions.",
          },
          {
            title: "Organization",
            image: "/images/gri/organisation.png",
            description:
              "Mission-aligned organizations led by individuals from marginalized communities.",
          },
        ]}
      />
      <Section variant="flatZero">
        <p className="text-darkBlue mb-16 text-justify lg:text-lg text-base">
          We hope to see our work helping grassroots organizations become robust
          and resilient with program delivery and financial health, and thriving
          together in an uncertain and complex world.
        </p>
      </Section>
      <CaseStories />
    </>
  );
}
